var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKlp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 72,
    viewBox: "0 0 119 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12_30)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.492 38.7109V62.197C79.492 64.4432 78.8647 66.1815 77.5999 67.4178C76.3361 68.6526 74.3978 69.2686 71.8125 69.2686C69.2269 69.2686 67.2872 68.6526 66.0238 67.4178C64.7601 66.1816 64.1304 64.4432 64.1304 62.197V0L47.882 5.35178V8.07378C54.556 8.54171 55.8685 8.16757 55.8685 16.3312V63.4794C55.8685 65.3197 55.3551 66.7448 54.3191 67.7576C53.2804 68.7689 51.6914 69.2766 49.5744 69.2766L49.1576 69.2752C49.0531 69.2766 49.6763 69.2766 49.5744 69.2766C44.7198 69.2396 42.5036 66.0971 39.9289 62.3293L26.589 43.1794L33.9165 36.2346C38.1453 32.2898 40.703 29.0029 46.906 28.8153V26.0997H25.7424V28.8153C28.9362 28.9118 30.5333 29.8505 30.5333 32.102C30.5333 34.5451 27.809 36.9816 26.3032 38.486L6.38476 58.547V59.1364C6.38476 67.9611 6.38476 68.5242 0.000671387 69.2752V72H21.1417V69.2752C14.6583 68.5243 14.6583 67.9611 14.6583 59.1364V54.3493L20.8586 48.5312L29.5966 60.826C30.4419 62.2352 32.5087 64.8633 32.5087 66.553C32.5087 68.8072 30.0662 69.2751 27.4359 69.2751V72H94.0543V69.2752C87.7628 68.4292 87.7628 67.8673 87.7628 59.0453V36.8904C87.7628 31.2969 88.0751 28.4967 95.5969 28.4967L95.5864 28.4821C103.766 28.5442 110.543 30.4202 110.73 40.4163C110.73 50.9727 103.631 52.7853 95.1352 52.7853H92.6186V55.1676H99.6855C109.305 55.1676 118.995 52.4189 118.995 40.8482C118.999 40.7055 119.001 40.5615 119.001 40.4149C119.001 28.8415 109.311 26.0968 99.6895 26.0968H73.1078V28.4792C79.4919 29.3254 79.492 29.8889 79.492 38.7109Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_30"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 119,
    height: 72,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKlp);
export default __webpack_public_path__ + "static/media/klp.e60274ec6406440e8f0d025ebd8a8a47.svg";
export { ForwardRef as ReactComponent };